/* eslint-disable */
import _ from 'underscore';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextension/shared');
var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var hours = ['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
var dayOptions = [{
  days: days.slice(0),
  displayName: i18n.get('AdExtensions_Scheduling_Day_All_Days')
}, {
  days: days.slice(1, 6),
  displayName: i18n.get('AdExtensions_Scheduling_Day_Monday_To_Friday')
}, {
  days: [days[1]],
  displayName: i18n.get('AdExtensions_Scheduling_Day_Monday')
}, {
  days: [days[2]],
  displayName: i18n.get('AdExtensions_Scheduling_Day_Tuesday')
}, {
  days: [days[3]],
  displayName: i18n.get('AdExtensions_Scheduling_Day_Wednesday')
}, {
  days: [days[4]],
  displayName: i18n.get('AdExtensions_Scheduling_Day_Thursday')
}, {
  days: [days[5]],
  displayName: i18n.get('AdExtensions_Scheduling_Day_Friday')
}, {
  days: [days[6]],
  displayName: i18n.get('AdExtensions_Scheduling_Day_Saturday')
}, {
  days: [days[0]],
  displayName: i18n.get('AdExtensions_Scheduling_Day_Sunday')
}];
_.each(dayOptions, function (option) {
  option.val = option.days.join();
});
var hourOptions = [{
  val: 0,
  twentyFourHourDisplay: '00',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_12AM_Start_Of_Day')
}, {
  val: 1,
  twentyFourHourDisplay: '01',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_1AM')
}, {
  val: 2,
  twentyFourHourDisplay: '02',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_2AM')
}, {
  val: 3,
  twentyFourHourDisplay: '03',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_3AM')
}, {
  val: 4,
  twentyFourHourDisplay: '04',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_4AM')
}, {
  val: 5,
  twentyFourHourDisplay: '05',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_5AM')
}, {
  val: 6,
  twentyFourHourDisplay: '06',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_6AM')
}, {
  val: 7,
  twentyFourHourDisplay: '07',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_7AM')
}, {
  val: 8,
  twentyFourHourDisplay: '08',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_8AM')
}, {
  val: 9,
  twentyFourHourDisplay: '09',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_9AM')
}, {
  val: 10,
  twentyFourHourDisplay: '10',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_10AM')
}, {
  val: 11,
  twentyFourHourDisplay: '11',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_11AM')
}, {
  val: 12,
  twentyFourHourDisplay: '12',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_12PM')
}, {
  val: 13,
  twentyFourHourDisplay: '13',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_1PM')
}, {
  val: 14,
  twentyFourHourDisplay: '14',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_2PM')
}, {
  val: 15,
  twentyFourHourDisplay: '15',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_3PM')
}, {
  val: 16,
  twentyFourHourDisplay: '16',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_4PM')
}, {
  val: 17,
  twentyFourHourDisplay: '17',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_5PM')
}, {
  val: 18,
  twentyFourHourDisplay: '18',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_6PM')
}, {
  val: 19,
  twentyFourHourDisplay: '19',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_7PM')
}, {
  val: 20,
  twentyFourHourDisplay: '20',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_8PM')
}, {
  val: 21,
  twentyFourHourDisplay: '21',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_9PM')
}, {
  val: 22,
  twentyFourHourDisplay: '22',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_10PM')
}, {
  val: 23,
  twentyFourHourDisplay: '23',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_11PM')
}, {
  val: 24,
  twentyFourHourDisplay: '24',
  twelveHourDisplay: i18n.get('AdExtensions_Scheduling_Time_12AM_End_Of_Day')
}];
var minuteOptions = [{
  val: 0,
  stringVal: 'ZERO',
  displayName: '00'
}, {
  val: 15,
  stringVal: 'FIFTEEN',
  displayName: '15'
}, {
  val: 30,
  stringVal: 'THIRTY',
  displayName: '30'
}, {
  val: 45,
  stringVal: 'FORTY_FIVE',
  displayName: '45'
}];
export default {
  days: days,
  hours: hours,
  dayOptions: dayOptions,
  fromHourOptions: hourOptions.slice(0, 24),
  toHourOptions: hourOptions.slice(0),
  minuteOptions: minuteOptions
};

